import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { modifier } from 'ember-modifier';

import { SIDEBAR_FULLSCREEN_CONTAINER_ID } from './sidebar-fullscreen-container.gts';

export class SidebarFullscreenButton extends Component<{
  Element: HTMLButtonElement;
}> {
  @tracked isFullscreen = this.getFullscreenStatus();

  toggleFullscreen = async (event: Event) => {
    event.preventDefault();
    if (document.fullscreenElement) {
      await document.exitFullscreen();
    } else {
      await document
        .getElementById(SIDEBAR_FULLSCREEN_CONTAINER_ID)!
        .requestFullscreen();
    }
  };

  trackFullScreen = modifier(() => {
    document.addEventListener('fullscreenchange', () => {
      this.isFullscreen = this.getFullscreenStatus();
    });
  });

  getFullscreenStatus() {
    return document.fullscreenElement !== null;
  }

  <template>
    <button
      type="button"
      {{on "click" this.toggleFullscreen}}
      {{this.trackFullScreen}}
      ...attributes
    >
      {{#if this.isFullscreen}}
        <iconify-icon inline icon="ph:corners-in-bold" class="me-1" />
        Exit Fullscreen
      {{else}}
        <iconify-icon inline icon="ph:square-bold" class="me-1" />
        Go Fullscreen
      {{/if}}
    </button>
  </template>
}
